/** @jsxImportSource @emotion/react */
import MuiFormControl, { type FormControlProps } from '@mui/material/FormControl';
import React from 'react';

export const FormControl = ({
  children,
  className,
  disabled,
  error,
  required,
}: Pick<FormControlProps, 'children' | 'className' | 'disabled' | 'error' | 'required'>) => (
  <MuiFormControl
    data-testid="nds-component-formcontrol"
    className={className}
    disabled={disabled}
    error={error}
    required={required}
  >
    {children}
  </MuiFormControl>
);
